// import React, { useState } from "react";
// import { Box, CssBaseline, Grid, Typography, IconButton } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useAuth } from "../../hooks/useAuth";
// import { auth } from "../../firebase";
// import logoImage from "../../assets/images/logoblue.png";

// import { signInWithEmailAndPassword } from "firebase/auth";
// import { DigitCodeLogin } from "../../authentication/components/components";
// import { getCurrentUser } from "../../authentication/hooks/AuthHooks";
// import { Link, useNavigate } from "react-router-dom";
// import { GeneralAdminRoutes, routes } from "../../constants";
// import { updateAdmin } from "../../modules/Admins/hooks/AdminsHook";
// import { LoadingButton } from "@mui/lab";
// import ReCAPTCHA from "react-google-recaptcha"; // Import reCAPTCHA
// import {
//   forgotPasswordStyles,
//   loginButtonStyles,
//   logoStyles,
//   mainContainerStyles,
//   passwordIconStyles,
//   textfieldStyles,
// } from "./styles";

// const LoginPage = () => {
//   const { onLogin, setCurrentUser, setCurrentLayoutAccess } = useAuth();
//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [emailError, setEmailError] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [showDigitCodeLogin, setShowDigitCodeLogin] = useState(false);
//   const [loginError, setLoginError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [recaptchaToken, setRecaptchaToken] = useState(""); // Token state for reCAPTCHA

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const validateForm = () => {
//     let isValid = true;

//     if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
//       setEmailError("Invalid email address");
//       isValid = false;
//     } else {
//       setEmailError("");
//     }

//     if (!password || password.length < 6) {
//       setPasswordError("Password must be at least 6 characters");
//       isValid = false;
//     } else {
//       setPasswordError("");
//     }

//     return isValid;
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     if (validateForm() && recaptchaToken) {
//       console.log("token:", recaptchaToken)
//       try {
//         setLoading(true);
//         await signInWithEmailAndPassword(auth, email, password);
//         const querySnap = await getCurrentUser();
//         if (querySnap.docs) {
//           setCurrentUser({
//             ...querySnap.docs[0].data(),
//             id: querySnap.docs[0].id,
//           });
//           await updateAdmin(querySnap.docs[0].id, {
//             lastLoginDate: new Date(),
//           });
//           onLogin();

//           if (querySnap.docs[0].data().type === "general") {
//             localStorage.removeItem("organizationId");
//             localStorage.setItem("currentLayoutAccess", "general");
//             setCurrentLayoutAccess("general");
//             navigate(GeneralAdminRoutes.dashboard);
//           } else {
//             localStorage.removeItem("organizationId");
//             localStorage.setItem("currentLayoutAccess", "organization");
//             setCurrentLayoutAccess("organization");
//             navigate(routes.addQuicktalesToOrg);
//           }
//         } else {
//           setLoginError("Some issue logging you");
//         }
//       } catch (error) {
//         setLoginError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     } else {
//       setLoginError("Please complete the reCAPTCHA verification");
//     }
//   };

//   const handleRecaptchaChange = (token) => {
//     setRecaptchaToken(token); // Store the token on success
//   };

//   return (
//     <Box>
//       <Box sx={mainContainerStyles}>
//         <CssBaseline />
//         {showDigitCodeLogin ? (
//           <DigitCodeLogin />
//         ) : (
//           <Grid
//             container
//             direction="column"
//             alignItems="center"
//             spacing={2}
//             maxWidth="336px"
//           >
//             <Grid item>
//               <img src={logoImage} alt="Logo" style={logoStyles} />
//             </Grid>

//             <form onSubmit={handleLogin}>
//               <Grid
//                 item
//                 display="flex"
//                 flexDirection="column"
//                 gap="4px"
//                 spacing={2}
//                 width="100%"
//               >
//                 <Typography>E-mail</Typography>
//                 <input
//                   type="text"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   error={!!emailError}
//                   helperText={emailError}
//                   placeholder="Enter your email"
//                   style={textfieldStyles}
//                 />
//               </Grid>
//               <Grid
//                 item
//                 display="flex"
//                 flexDirection="column"
//                 gap="4px"
//                 spacing={2}
//                 width="100%"
//                 marginTop="10px"
//               >
//                 <Typography>Password</Typography>
//                 <div style={{ position: "relative", width: "100%" }}>
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     error={!!passwordError}
//                     helperText={passwordError}
//                     placeholder="Enter your password"
//                     style={{ ...textfieldStyles, marginBottom: "10px" }}
//                   />
//                   <div style={passwordIconStyles}>
//                     <IconButton onClick={togglePasswordVisibility} edge="end">
//                       {showPassword ? <Visibility /> : <VisibilityOff />}
//                     </IconButton>
//                   </div>
//                 </div>
//                 {loginError && (
//                   <Grid item width="336px">
//                     <Typography
//                       variant="body2"
//                       textAlign="center"
//                       fontSize={15}
//                       fontWeight={500}
//                       color="error"
//                     >
//                       {loginError}
//                     </Typography>
//                   </Grid>
//                 )}
//               </Grid>

//               {/* reCAPTCHA widget */}
//               <Grid item width="336px" marginTop="15px">
//                 <ReCAPTCHA
//                   sitekey={
//                     process.env.REACT_APP_PROJECT_ENVIROMENT === "development"
//                       ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_DEV
//                       : process.env.REACT_APP_PROJECT_ENVIROMENT ===
//                         "production"
//                       ? process.env.REACT_APP_RECAPTCHA_SITE_KEY_PRODUCTION
//                       : process.env.REACT_APP_RECAPTCHA_SITE_KEY_STAGING
//                   }
//                   // sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} // Add your site key in env
//                   onChange={handleRecaptchaChange}
//                 />
//               </Grid>

//               <Grid item width="336px" marginTop="15px">
//                 <LoadingButton
//                   variant="contained"
//                   color="primary"
//                   type="submit"
//                   loading={loading}
//                   style={loginButtonStyles}
//                 >
//                   Login
//                 </LoadingButton>
//               </Grid>
//             </form>

//             <Grid item width="336px">
//               <Typography
//                 variant="body2"
//                 textAlign="center"
//                 fontSize={15}
//                 fontWeight={700}
//               >
//                 <Link to="/forgot-password" style={forgotPasswordStyles}>
//                   Forgot password?
//                 </Link>
//               </Typography>
//             </Grid>
//           </Grid>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default LoginPage;

import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Box, CssBaseline, Grid, Typography, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "../../hooks/useAuth";
import { auth } from "../../firebase";
import { DigitCodeLogin } from "../../authentication/components/components";
import { getCurrentUser } from "../../authentication/hooks/AuthHooks";
import { GeneralAdminRoutes, routes } from "../../constants";
import { updateAdmin } from "../../modules/Admins/hooks/AdminsHook";
import logoImage from "../../assets/images/logoblue.png";
import {
  forgotPasswordStyles,
  loginButtonStyles,
  logoStyles,
  mainContainerStyles,
  passwordIconStyles,
  textfieldStyles,
} from "./styles";

const LoginPage = () => {
  const { onLogin, setCurrentUser, setCurrentLayoutAccess } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showDigitCodeLogin, setShowDigitCodeLogin] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    let isValid = true;

    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setEmailError("Invalid email address");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!password || password.length < 6) {
      setPasswordError("Password must be at least 6 characters");
      isValid = false;
    } else {
      setPasswordError("");
    }

    return isValid;
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        setLoading(true);

        // Perform login
        await signInWithEmailAndPassword(auth, email, password);
        const querySnap = await getCurrentUser();

        if (querySnap.docs) {
          if (querySnap.docs[0].data().status === "inactive") {
            setLoginError("Your account is inactive");
          } else {
            setCurrentUser({
              ...querySnap.docs[0].data(),
              id: querySnap.docs[0].id,
            });

            await updateAdmin(querySnap.docs[0].id, {
              lastLoginDate: new Date(),
            });
            onLogin();

            // Set layout access but don't navigate - let AuthProvider handle navigation
            if (querySnap.docs[0].data().type === "general") {
              localStorage.removeItem("organizationId");
              localStorage.setItem("currentLayoutAccess", "general");
              setCurrentLayoutAccess("general");
              sessionStorage.setItem("user", true);
            } else {
              localStorage.removeItem("organizationId");
              localStorage.setItem("currentLayoutAccess", "organization");
              setCurrentLayoutAccess("organization");
              sessionStorage.setItem("user", true);
            }
            // Navigation will be handled by AuthProvider using stored finalRoute
          }
        } else {
          setLoginError("Some issue logging you in");
        }
      } catch (error) {
        setLoginError(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box>
      <Box sx={mainContainerStyles}>
        <CssBaseline />
        {showDigitCodeLogin ? (
          <DigitCodeLogin />
        ) : (
          <Grid
            container
            direction="column"
            alignItems="center"
            spacing={2}
            maxWidth="336px"
          >
            <Grid item>
              <img src={logoImage} alt="Logo" style={logoStyles} />
            </Grid>

            <form onSubmit={handleLogin}>
              <Grid
                item
                display="flex"
                flexDirection="column"
                gap="4px"
                spacing={2}
                width="100%"
              >
                <Typography>E-mail</Typography>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!emailError}
                  helperText={emailError}
                  placeholder="Enter your email"
                  style={textfieldStyles}
                />
              </Grid>
              <Grid
                item
                display="flex"
                flexDirection="column"
                gap="4px"
                spacing={2}
                width="100%"
                marginTop="10px"
              >
                <Typography>Password</Typography>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!passwordError}
                    helperText={passwordError}
                    placeholder="Enter your password"
                    style={{ ...textfieldStyles, marginBottom: "10px" }}
                  />
                  <div style={passwordIconStyles}>
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </div>
                </div>
                {loginError && (
                  <Grid item width="336px">
                    <Typography
                      variant="body2"
                      textAlign="center"
                      fontSize={15}
                      fontWeight={500}
                      color="error"
                    >
                      {loginError}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Grid item width="336px" marginTop="15px">
                <LoadingButton
                  variant="contained"
                  color="primary"
                  type="submit"
                  loading={loading}
                  style={loginButtonStyles}
                >
                  Login
                </LoadingButton>
              </Grid>
            </form>

            <Grid item width="336px">
              <Typography
                variant="body2"
                textAlign="center"
                fontSize={15}
                fontWeight={700}
              >
                <Link to="/forgot-password" style={forgotPasswordStyles}>
                  Forgot password?
                </Link>
              </Typography>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default LoginPage;
